import React from 'react';

import { UniversalLink } from '@plone/volto/components';
import { defineMessages, useIntl } from 'react-intl';

import LogoE015 from './logo-e015.png';

const messages = defineMessages({
  integrated_brand: {
    id: 'integrated_brand',
    defaultMessage: 'Integrato con',
  },
  integrated_brand_logo: {
    id: 'integrated_brand_logo',
    defaultMessage: 'Integrato con E015 Digital Ecosystem',
  },
});

const AdditionalColumn = () => {
  const intl = useIntl();

  const linkE015 = 'https://www.e015.regione.lombardia.it/site/index';

  return (
    <>
      <h3>{intl.formatMessage(messages.integrated_brand)}</h3>
      <UniversalLink href={linkE015} className="img-link">
        <img
          src={LogoE015}
          alt={intl.formatMessage(messages.integrated_brand_logo)}
          loading="lazy"
        />
      </UniversalLink>
    </>
  );
};

export default AdditionalColumn;
